"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GZIconTypes = exports.DigitalIconTypes = exports.ClpIconTypes = exports.PlakatIconTypes = exports.IconTypesEnum = void 0;
exports.isPlakat = isPlakat;
exports.isClp = isClp;
exports.isGZ = isGZ;
exports.isDigital = isDigital;
exports.isGD = isGD;
exports.isVD = isVD;
exports.isLastMinute = isLastMinute;
exports.isLastMinutePosterMapIconType = isLastMinutePosterMapIconType;
exports.isLastMinuteClpMapIconType = isLastMinuteClpMapIconType;
exports.isLastMinuteGZMapIconType = isLastMinuteGZMapIconType;
exports.isAction = isAction;
exports.getIconTypeClass = getIconTypeClass;
exports.getFormatDescription = getFormatDescription;
exports.getIconTypeName = getIconTypeName;
exports.getIconTypeNames = getIconTypeNames;
exports.getIconTypeString = getIconTypeString;
var IconTypesEnum;
(function (IconTypesEnum) {
    IconTypesEnum[IconTypesEnum["UNKNOWN"] = 0] = "UNKNOWN";
    IconTypesEnum[IconTypesEnum["STANDARD_POSTER"] = 1] = "STANDARD_POSTER";
    IconTypesEnum[IconTypesEnum["ACTION_POSTER"] = 2] = "ACTION_POSTER";
    IconTypesEnum[IconTypesEnum["STANDARD_CLP"] = 3] = "STANDARD_CLP";
    IconTypesEnum[IconTypesEnum["ACTION_CLP"] = 4] = "ACTION_CLP";
    IconTypesEnum[IconTypesEnum["LAST_MINUTE_POSTER"] = 5] = "LAST_MINUTE_POSTER";
    IconTypesEnum[IconTypesEnum["LAST_MINUTE_CLP"] = 6] = "LAST_MINUTE_CLP";
    IconTypesEnum[IconTypesEnum["CONFIRMED_POSTER"] = 7] = "CONFIRMED_POSTER";
    IconTypesEnum[IconTypesEnum["CONFIRMED_CLP"] = 8] = "CONFIRMED_CLP";
    IconTypesEnum[IconTypesEnum["FAILED_POSTER"] = 9] = "FAILED_POSTER";
    IconTypesEnum[IconTypesEnum["FAILED_CLP"] = 10] = "FAILED_CLP";
    IconTypesEnum[IconTypesEnum["CANCELLED_POSTER"] = 11] = "CANCELLED_POSTER";
    IconTypesEnum[IconTypesEnum["CANCELLED_CLP"] = 12] = "CANCELLED_CLP";
    IconTypesEnum[IconTypesEnum["STANDARD_GD"] = 13] = "STANDARD_GD";
    IconTypesEnum[IconTypesEnum["STANDARD_VD"] = 14] = "STANDARD_VD";
    IconTypesEnum[IconTypesEnum["CONFIRMED_GD"] = 15] = "CONFIRMED_GD";
    IconTypesEnum[IconTypesEnum["CONFIRMED_VD"] = 16] = "CONFIRMED_VD";
    IconTypesEnum[IconTypesEnum["FAILED_GD"] = 17] = "FAILED_GD";
    IconTypesEnum[IconTypesEnum["FAILED_VD"] = 18] = "FAILED_VD";
    IconTypesEnum[IconTypesEnum["CANCELLED_GD"] = 19] = "CANCELLED_GD";
    IconTypesEnum[IconTypesEnum["CANCELLED_VD"] = 20] = "CANCELLED_VD";
    IconTypesEnum[IconTypesEnum["STANDARD_GZ"] = 21] = "STANDARD_GZ";
    IconTypesEnum[IconTypesEnum["ACTION_GZ"] = 22] = "ACTION_GZ";
    IconTypesEnum[IconTypesEnum["LAST_MINUTE_GZ"] = 23] = "LAST_MINUTE_GZ";
    IconTypesEnum[IconTypesEnum["CONFIRMED_GZ"] = 24] = "CONFIRMED_GZ";
    IconTypesEnum[IconTypesEnum["FAILED_GZ"] = 25] = "FAILED_GZ";
    IconTypesEnum[IconTypesEnum["CANCELLED_GZ"] = 26] = "CANCELLED_GZ";
})(IconTypesEnum || (exports.IconTypesEnum = IconTypesEnum = {}));
exports.PlakatIconTypes = [
    IconTypesEnum.STANDARD_POSTER,
    IconTypesEnum.ACTION_POSTER,
    IconTypesEnum.LAST_MINUTE_POSTER
];
exports.ClpIconTypes = [
    IconTypesEnum.STANDARD_CLP,
    IconTypesEnum.ACTION_CLP,
    IconTypesEnum.LAST_MINUTE_CLP
];
exports.DigitalIconTypes = [
    IconTypesEnum.STANDARD_VD,
    IconTypesEnum.STANDARD_GD
];
exports.GZIconTypes = [
    IconTypesEnum.STANDARD_GZ,
    IconTypesEnum.ACTION_GZ,
    IconTypesEnum.LAST_MINUTE_GZ
];
function isPlakat(iconType) {
    const posterTypes = [
        IconTypesEnum.STANDARD_POSTER,
        IconTypesEnum.ACTION_POSTER,
        IconTypesEnum.LAST_MINUTE_POSTER,
        IconTypesEnum.CONFIRMED_POSTER,
        IconTypesEnum.FAILED_POSTER,
        IconTypesEnum.CANCELLED_POSTER,
    ];
    return posterTypes.includes(iconType);
}
function isClp(iconType) {
    const clpTypes = [
        IconTypesEnum.STANDARD_CLP,
        IconTypesEnum.ACTION_CLP,
        IconTypesEnum.LAST_MINUTE_CLP,
        IconTypesEnum.CONFIRMED_CLP,
        IconTypesEnum.FAILED_CLP,
        IconTypesEnum.CANCELLED_CLP,
    ];
    return clpTypes.includes(iconType);
}
function isGZ(iconType) {
    const gzTypes = [
        IconTypesEnum.STANDARD_GZ,
        IconTypesEnum.ACTION_GZ,
        IconTypesEnum.LAST_MINUTE_GZ,
        IconTypesEnum.CONFIRMED_GZ,
        IconTypesEnum.FAILED_GZ,
        IconTypesEnum.CANCELLED_GZ,
    ];
    return gzTypes.includes(iconType);
}
function isDigital(iconType) {
    const digitalTypes = [
        IconTypesEnum.STANDARD_GD,
        IconTypesEnum.STANDARD_VD,
        IconTypesEnum.CONFIRMED_GD,
        IconTypesEnum.CONFIRMED_VD,
        IconTypesEnum.FAILED_GD,
        IconTypesEnum.FAILED_VD,
        IconTypesEnum.CANCELLED_GD,
        IconTypesEnum.CANCELLED_VD,
    ];
    return digitalTypes.includes(iconType);
}
function isGD(iconType) {
    const gdTypes = [
        IconTypesEnum.STANDARD_GD,
        IconTypesEnum.CONFIRMED_GD,
        IconTypesEnum.FAILED_GD,
        IconTypesEnum.CANCELLED_GD,
    ];
    return gdTypes.includes(iconType);
}
function isVD(iconType) {
    const vdTypes = [
        IconTypesEnum.STANDARD_VD,
        IconTypesEnum.CONFIRMED_VD,
        IconTypesEnum.FAILED_VD,
        IconTypesEnum.CANCELLED_VD,
    ];
    return vdTypes.includes(iconType);
}
function isLastMinute(iconType) {
    return (iconType === IconTypesEnum.LAST_MINUTE_POSTER ||
        iconType === IconTypesEnum.LAST_MINUTE_CLP ||
        iconType === IconTypesEnum.LAST_MINUTE_GZ);
}
function isLastMinutePosterMapIconType(iconType) {
    return (iconType === IconTypesEnum.LAST_MINUTE_POSTER);
}
function isLastMinuteClpMapIconType(iconType) {
    return (iconType === IconTypesEnum.LAST_MINUTE_CLP);
}
function isLastMinuteGZMapIconType(iconType) {
    return (iconType === IconTypesEnum.LAST_MINUTE_GZ);
}
function isAction(iconType) {
    return (iconType === IconTypesEnum.ACTION_POSTER ||
        iconType === IconTypesEnum.ACTION_CLP ||
        iconType === IconTypesEnum.ACTION_GZ);
}
function getIconTypeClass(iconType) {
    switch (iconType) {
        case IconTypesEnum.STANDARD_CLP:
        case IconTypesEnum.ACTION_CLP:
        case IconTypesEnum.LAST_MINUTE_CLP:
            return 'clp';
        case IconTypesEnum.STANDARD_VD:
            return 'vd';
        case IconTypesEnum.STANDARD_GD:
            return 'gd';
        case IconTypesEnum.STANDARD_GZ:
        case IconTypesEnum.ACTION_GZ:
        case IconTypesEnum.LAST_MINUTE_GZ:
            return 'gz';
        default:
            return 'gf';
    }
}
function getFormatDescription(iconType) {
    let format;
    if (iconType === IconTypesEnum.STANDARD_VD) {
        format = '2.160 px x 3840 px (B x H)';
    }
    else if (iconType === IconTypesEnum.STANDARD_GD) {
        format = '576 px x 384 px (B x H)';
    }
    else if (isClp(iconType)) {
        format = '119,6 cm x 175,6 cm (B x H)';
    }
    else if (isPlakat(iconType)) {
        format = '59 cm x 41 cm (B x H)';
    }
    else if (isGZ(iconType)) {
        format = '198mm x 420mm (B x H)';
    }
    return format;
}
function getIconTypeName(iconType) {
    switch (iconType) {
        case IconTypesEnum.STANDARD_CLP:
            return 'Standard-Collection-Poster';
        case IconTypesEnum.ACTION_CLP:
            return 'Economy-Plus-Poster';
        case IconTypesEnum.LAST_MINUTE_POSTER:
            return 'Premium Last-Minute-Plakat';
        case IconTypesEnum.ACTION_POSTER:
            return 'Economy-Plus-Plakat';
        case IconTypesEnum.LAST_MINUTE_CLP:
            return 'Premium Last-Minute-Poster';
        case IconTypesEnum.STANDARD_GD:
        case IconTypesEnum.STANDARD_VD:
            return 'Digitales Plakat';
        case IconTypesEnum.STANDARD_GZ:
            return 'Standard-Collection-Werbesäule';
        case IconTypesEnum.ACTION_GZ:
            return 'Economy-Plus-Werbesäule';
        case IconTypesEnum.LAST_MINUTE_GZ:
            return 'Premium Last-Minute-Werbesäule';
        default:
            return 'Standard-Collection-Plakat';
    }
}
function getIconTypeNames(iconType) {
    switch (iconType) {
        case IconTypesEnum.STANDARD_CLP:
            return 'Standard-Collection-Poster';
        case IconTypesEnum.STANDARD_GZ:
            return 'Standard-Collection-Werbesäulen';
        default:
            return 'Standard-Collection-Plakate';
    }
}
function getIconTypeString(iconType, isCombinedPriceScale) {
    switch (iconType) {
        case IconTypesEnum.STANDARD_POSTER:
            return 'ein Plakat';
        case IconTypesEnum.ACTION_POSTER:
            return isCombinedPriceScale
                ? 'ein Premium Last-Minute- oder Economy-Plus-Plakat'
                : 'ein Economy-Plus-Plakat';
        case IconTypesEnum.LAST_MINUTE_POSTER:
            return isCombinedPriceScale
                ? 'ein Premium Last-Minute- oder Economy-Plus-Plakat'
                : 'ein Premium Last-Minute-Plakat';
        case IconTypesEnum.STANDARD_CLP:
            return 'ein Citylight-Poster';
        case IconTypesEnum.ACTION_CLP:
            return isCombinedPriceScale
                ? 'ein Premium Last-Minute- oder Economy-Plus-Poster'
                : 'ein Economy-Plus-Poster';
        case IconTypesEnum.LAST_MINUTE_CLP:
            return isCombinedPriceScale
                ? 'ein Premium Last-Minute- oder Economy-Plus-Poster'
                : 'ein Premium Last-Minute-Poster';
        case IconTypesEnum.STANDARD_GZ:
            return 'eine Werbesäule';
        case IconTypesEnum.ACTION_GZ:
            return isCombinedPriceScale
                ? 'eine Premium Last-Minute- oder Economy-Plus-Werbesäule'
                : 'eine Economy-Plus-Werbesäule';
        case IconTypesEnum.LAST_MINUTE_GZ:
            return isCombinedPriceScale
                ? 'eine Premium Last-Minute- oder Economy-Plus-Werbesäule'
                : 'eine Premium Last-Minute-Werbesäule';
        default:
            return 'ein Plakat';
    }
}
